import { Link } from "react-router-dom";

export default function UnavailableView({
  eventId,
  title = "Bout No Longer Available",
  message = "This bout was removed or the tournament was reset. Return to the event page for the current schedule.",
}) {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-dark-900 p-6 text-center" style={{ zIndex: 9999 }}>
      <div className="w-full max-w-sm">
        <div className="text-4xl mb-4">&#8634;</div>
        <h2 className="font-display text-xl font-bold mb-2">{title}</h2>
        <p className="text-gray-500 text-sm mb-6">{message}</p>
        <div className="flex flex-col gap-2">
          {eventId && (
            <Link
              to={`/public/${eventId}`}
              className="w-full box-border px-6 py-3 bg-green-action-light rounded-xl text-white font-display font-bold text-sm no-underline"
            >
              Event Home
            </Link>
          )}
          <Link
            to="/"
            className="w-full box-border px-6 py-3 bg-dark-700 border border-dark-500 rounded-xl text-gray-300 font-display font-bold text-sm no-underline"
          >
            Enter a Code
          </Link>
        </div>
      </div>
    </div>
  );
}
